module.exports = __webpack_public_path__ + "static/media/octorion-mission.60bc1703.svg";